import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { Phase } from '@/types/phase';
import { QueryParams } from '@/types/query';

const basePath = '/api/dugout/phase';

export const phaseRepository = createRepository<Phase, Phase>(basePath);

const PhaseRepository = () => {
  const { host } = useContext(AppContext);
  const { create, update, list, get } = phaseRepository;

  return {
    async create({ data }: { data: Partial<Phase> }) {
      return create({ host, data });
    },

    async update({ id, data }: { id: string; data: Partial<Phase> }) {
      return update({ host, id, data });
    },

    async get({ id }: { id: string }) {
      return get({ host, id });
    },

    async list(params: QueryParams = {}) {
      return list({ host, params });
    }
  };
};

export default PhaseRepository;
